/**
 * The app's only rendered `<title>` element.
 *
 * Outside hydration React 19 does not adopt the document's existing `<title>`:
 * it builds its own node and inserts it *before* `head > title`, then removes
 * that node when the last title fiber unmounts. So index.html's static title
 * stays behind this one as the pre-commit fallback, and a title rendered per
 * page would drop the tab back to it on every page that declared none. One
 * owner, mounted for the whole session and reading the matched routes'
 * metadata, keeps the route's title first in `<head>` — the one the browser
 * reads — on every route.
 */

import { type ReactElement } from 'react'
import { useMatches } from 'react-router-dom'
import { resolveDocumentTitle } from '@/routes/routeHandle'

function DocumentTitle(): ReactElement {
  const matches = useMatches()

  // A single string child: any other shape leaves the node's text untouched.
  return <title>{resolveDocumentTitle(matches)}</title>
}

export default DocumentTitle
